import useDocument, { DocumentConfig } from './useDocument';
import { Proposal, ProposalStatus } from '../models/proposal';

const config: DocumentConfig = {
  listKey: 'proposals',
  detailKey: 'proposal',
  basePath: 'proposal',
  archivePath: (id) => `proposal/archiveProposal/${id}`,
  voidPath: (id) => `proposal/voidProposal/${id}`,
  voidType: 'Proposal', // EPIC_VOID_FLOW_2026-10
  unvoidPath: (id) => `proposal/UnVoidProposal/${id}`,
  statusPath: (id) => `proposal/SetStatus/${id}`,
  statusAsJson: true,
  // item 485 — archiving a proposal MOVES it out of the main list into the Archived filter view
  archiveRemovesRow: true,
  archivedKey: 'proposalsArchived',
};

const useProposal = (props: { id?: string }) => {
  const doc = useDocument<ProposalStatus, Proposal>(config, props);
  return { ...doc, tryChangeStatus: doc.tryStatus };
};

export default useProposal;
